import { styled } from "@mui/material"
import { observer } from "mobx-react"
import React, { useMemo } from "react"

const ImagePreviewWrap = styled("div")(({ theme }) => ({
    backgroundColor: theme.palette.common.white,
    backgroundPosition: "center",
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    width: "100%",
    borderRadius: theme.shape.borderRadius,
    position: "relative",
    overflow: "hidden",
}))

interface IProps {
    url: string
    children?: React.ReactNode
    aspectRatio?: string
}

export const ImagePreview = observer((props: IProps) => {
    // Calculate explicit dimensions similar to UploadImageField
    const dimensions = useMemo(() => {
        if (props.aspectRatio == null || props.aspectRatio === "") {
            return {
                height: { xs: "64px", sm: "128px" },
            }
        }

        // Parse aspect ratio and calculate dimensions
        const separator = props.aspectRatio.includes(":") ? ":" : "/"
        const [ratioWidth, ratioHeight] = props.aspectRatio
            .split(separator)
            .map(Number)
        const isSquare = ratioWidth === ratioHeight

        if (isSquare) {
            return {
                width: "100px",
                height: "100px",
            }
        }

        // For non-square, use aspectRatio CSS property
        return {
            aspectRatio: props.aspectRatio,
            height: "auto",
            minHeight: "64px",
        }
    }, [props.aspectRatio])

    return (
        <ImagePreviewWrap
            sx={{
                backgroundImage: `url(${props.url})`,
                ...dimensions,
            }}
        >
            {props.children}
        </ImagePreviewWrap>
    )
})
